export const sortLocaleOptions = (locales) => {
    const result = [...locales];
    result.sort((a, b) => a.label.localeCompare(b.label));
    return result;
};
